// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sH2MC","footer":"styles_footer__3FPPQ"};